import { AlertService } from 'ngx-alerts';
import { catchError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommentDto, UpdateCommentDto } from './comments.dto';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})
export class CommentsService {
    private api: string = environment.api;
    constructor(
        private _httpClient: HttpClient,
        private alertService: AlertService
    ) {}

    getAllComments(trasactionId: string) {
        return this._httpClient.get(`${this.api}/message/${trasactionId}`).pipe(
            catchError((error) => {
                throw new Error(error);
            })
        );
    }

    setComment(body: any) {
        return this._httpClient.post(`${this.api}/message`, body).pipe(
            catchError((error) => {
                throw new Error(error);
            })
        );
    }

    editComment(body: { id: number; message: string; userId: number }) {
        return this._httpClient.patch(`${this.api}/message`, body).pipe(
            catchError((response) => {
                if (response.error.e.message)
                    this.alertService.danger(response.error.e.message);

                throw new Error(response.error.e.message);
            })
        );
    }

    deleteComment(id: number, userId: number, username: string) {
        return this._httpClient
            .delete(`${this.api}/message`, { body: { id, userId, username } })
            .pipe(
                catchError((response) => {
                    if (response.error.e.message)
                        this.alertService.danger(response.error.e.message);

                    throw new Error(response.error.e.message);
                })
            );
    }

    // UI-COMMENTS methods

    getAllWithdrawCommentsByTransactionId(trasactionId: string) {
        return this._httpClient
            .get(`${this.api}/withdrawcomments/${trasactionId}`)
            .pipe(
                catchError((error) => {
                    throw new Error(error);
                })
            );
    }

    getAllWithdrawCommentsByUserId(userId: string) {
        return this._httpClient
            .get(`${this.api}/withdrawcomments/getByUserId/${userId}`)
            .pipe(
                catchError((error) => {
                    throw new Error(error);
                })
            );
    }

    createWithdrawComment(body: CommentDto) {
        return this._httpClient.post(`${this.api}/withdrawcomments`, body).pipe(
            catchError((error) => {
                throw new Error(error);
            })
        );
    }

    updateWithdrawComment(body: UpdateCommentDto) {
        return this._httpClient
            .patch(`${this.api}/withdrawcomments`, body)
            .pipe(
                catchError((response) => {
                    if (response.error.e.message)
                        this.alertService.danger(response.error.e.message);

                    throw new Error(response.error.e.message);
                })
            );
    }

    deleteWithdrawComment(id: number) {
        return this._httpClient
            .delete(`${this.api}/withdrawcomments`, { body: { id: '' + id } })
            .pipe(
                catchError((response) => {
                    if (response.error.e.message)
                        this.alertService.danger(response.error.e.message);

                    throw new Error(response.error.e.message);
                })
            );
    }
}
